module.exports = __webpack_public_path__ + "static/media/food-app-4.47b24f29.jpg";